import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { useNavigate } from "react-router-dom";
import { encryptClientPassword } from "../../utils/helper";

import { IconOpenEye } from "../../components/Icons/IconOpenEye";
import { IconCloseEye } from "../../components/Icons/IconCloseEye";
import { InputOtp } from "../../components/TwoFA/style";
import {
  ssoSetPassword,
  ssoSetPasswordRequest,
  ssoSetPasswordVerifyOtp,
  ssoGetUserInfo,
} from "../../services/app";
import { validatePassword } from "../../utils/helper";
import * as Notification from "../../Notification";

const ERROR_DEFAULT = {
  new_password: "",
  confirm_password: "",
  verify_code: "",
  verify_coded: "",
  form: "",
};
const OTP_TIME = 180;

export const SetPassword = () => {
  const { T, user, language } = useApp();

  const [formData, $formData] = useState({
    new_password: "",
    confirm_password: "",
    verify_code: "",
    verify_coded: "",
    requestId: "",
  });
  const [step, setStep] =  useState(1);
  const [showNewPassword, $showNewPassword] = useState(false);
  const [userData, setUserData] = useState({});
  const [showConfirmPassword, $showConfirmPassword] = useState(false);

  const [otpCountdown, $otpCountdown] = useState(OTP_TIME);
  const [isSendingOtp, $isSendingOtp] = useState(false);
  const [countSend, $countSend] = useState(0);
  const navigate = useNavigate();

  const [otpMessage, $otpMessage] = useState("");
  const stopTimer = () => {
    if (timerOtp) {
      clearInterval(timerOtp);
      timerOtp = null;
    }
  };

  const changeVerifyCode = (val) => {
    $formData({
      ...formData,
      verify_code: val,
    });
  };
  const handleSendCode = () => {
    changeVerifyCode("");
    $otpMessage("");
    if (isSendingOtp) return;
    $otpCountdown(OTP_TIME);
    $isSendingOtp(() => {
      if (isSendingOtp) return true;
      sendCode();
      return true;
    });
  };

  const sendCode = () => {
    ssoSetPasswordRequest()
      .then((res) => {
        const data = res.data.data || null;
        if (data) {
          changeInput("requestId", data.request_id);
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
        $isSendingOtp(false);
        stopTimer();
        changeInput("requestId", "");
        $otpMessage(T("Failed to request set password"));
      });
  };
  const handlePhoneConfirmOtp = async () => {
    if (otpCountdown <= 0 || !formData.verify_code) return;
    ssoSetPasswordVerifyOtp({
      otp: formData.verify_code,
      request_id: formData.requestId,
    }).then((res) => {
      if (res.data.status) {
        changeInput("verify_coded", res?.data?.data?.verify_code);
        setStep(2);
      } else {
        $otpMessage(res.data.message || T("title.phone_verify_fail"));
      }
    }).catch(err => {
      console.log("ERROR", err);
      $otpMessage(err.message || T("title.phone_verify_fail"));
    })
  }

  let timerOtp;
  const countDown = () => {
    if (timerOtp) {
      clearInterval(timerOtp);
    }
    timerOtp = setInterval(() => {
      $otpCountdown((val) => {
        const newVal = val - 1;
        if (newVal <= 0) {
          clearInterval(timerOtp);
          timerOtp = null;
          $isSendingOtp(false);
        }
        return newVal;
      });
    }, 1000);
  };
  useEffect(() => {
    if (isSendingOtp) {
      countDown();
    }
  }, [isSendingOtp]);

  const [error, $error] = useState(ERROR_DEFAULT);

  const triggerShowNewPassword = () => {
    $showNewPassword(!showNewPassword);
  };
  const triggerShowConfirmPassword = () => {
    $showConfirmPassword(!showConfirmPassword);
  };

  const changeInput = (key, val) => {
    $formData((data) => {
      data[key] = val;
      return data;
    });
  };
  const validateForm = () => {
    const errors = {};
    if (formData.confirm_password !== formData.new_password) {
      errors["confirm_password"] = T("Confirm new password not match.");
      return errors;
    }

    if (!validatePassword(formData.new_password)) {
      errors["new_password"] = T(
        "The password must contain 6 pure letters or is a combination of letters and numbers"
      );
      return errors;
    }
  
    return true;
  };
  const loadProfile = () => {
    ssoGetUserInfo().then(res => {
        const data = res.data?.data || {}
        setUserData(data);
        if (data.has_password) {
          navigate(-1);
        }
      })
  }
  useEffect(() => {
    loadProfile();
    handleSendCode();
  },[])

  const changePassword = (e) => {
    ssoSetPassword({
      new_password: encryptClientPassword(formData.new_password),
      verify_code: formData.verify_coded,
    })
      .then((res) => {
        if (res?.data?.status) {
          Notification.success(T("Set password successfully."));
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          if (res?.data?.code == -1) {
            Notification.error(T(res?.data?.message));
          } else {
            $error({ ...ERROR_DEFAULT, form: T("Set password fail.") });
          }
        }
      })
      .catch((err) => {
        console.log("AccountService.changePassword=>ERROR", err);
        Notification.error(T("Set password fail."));
      });
  };
  const submitFormChangePassword = (e) => {
    e.preventDefault();
    const resValid = validateForm();
    if (resValid !== true) {
      $error({ ...ERROR_DEFAULT, ...resValid });
      return;
    }
    $error(ERROR_DEFAULT);

    changePassword(e);
  };

  return (
    <Container>
      <ContainerView background="transparent">
        <div className="max-w-[400px] mx-auto mt-[25px]">
          <TitlePage style={{ fontSize: "30px" }}>
            {T("Set new password")}
          </TitlePage>
          <div className="flex justify-between items-start w-full  container mt-[32px] lg:gap-12">
            <div className="w-full block grow-1">
              {step == 1 && (
                <div
                  className={`max-w-full mx-auto relative transition ease-in-out`}
                >
                  <div className="flex items-center justify-center lg:justify-start max-w-full mx-auto lg:w-full mb-[25px] lg:mb-[30px] flex-col">
                    <label
                      htmlFor="form_verify_email"
                      className="text-black w-full block pb-2"
                    >
                      {T(
                        "We have sent verification code into your registered email."
                      )}
                    </label>
                    <div className="w-full">
                      <div className="p-[1px] rounded-[10px] relative max-w-full">
                        <input
                          id="form_verify_email"
                          type="tel"
                          maxLength="6"
                          pattern="[0-9]{6}"
                          className="h-[52px] max-w-full w-[486px]  border border-solid border-[#ddd] pl-5 pr-32 py-3 bg-white rounded-[8px] text-black input-gradient appearance-none"
                          value={userData.email}
                        />
                        <div className="bg-mark"></div>
                        {countSend < 3 && !isSendingOtp && (
                          <button
                            className="absolute right-px top-px h-[50px] z-10 px-5 text-aia-red"
                            onClick={() => handleSendCode()}
                          >
                            {T("Resend")}
                          </button>
                        )}
                        {countSend <= 3 && isSendingOtp && (
                          <button className="absolute right-px top-px h-[50px] z-10 px-5 text-aia-red">{`${otpCountdown}s`}</button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex lg:items-center justify-center w-full mt-[50px] mb-[25px] lg:mb-[30px] flex-col">
                    <label
                      htmlFor="form_verify_code"
                      className="text-black w-full text-center block pb-1 lg:pb-0"
                    >
                      {T("Please input 6-digit code")}
                    </label>
                    <div className="w-full relative input-otp mt-[25px]">
                      <InputOtp
                        className="justify-center flex"
                        value={formData.verify_code}
                        onChange={(event) => {
                          changeVerifyCode(event);
                        }}
                      />
                      {otpMessage && (
                        <p className="text-suzu-error text-xs py-2 text-center">
                          {otpMessage}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-center items-center pt-0 lg:pt-12 gap-[15px] flex-col-reverse sm:flex-row">
                    <button
                      className="w-full sm:w-40 h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
                      disabled={
                        !formData.verify_code ||
                        formData.verify_code.length !== 6
                      }
                      onClick={handlePhoneConfirmOtp}
                    >
                      {T("Confirm")}
                    </button>
                  </div>
                </div>
              )}

              {step == 2 && (
                <>
                  <form
                    className="w-full"
                    onSubmit={submitFormChangePassword}
                    id="form_change_password"
                  >
                    <div className="mb-6 lg:mb-[25px]">
                      <label
                        htmlFor="form_new_password"
                        className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                      >
                        {T("New Password")}
                      </label>
                      <div className="w-full p-[1px] rounded-[10px] relative">
                        <input
                          id="form_new_password"
                          type={showNewPassword ? "text" : "password"}
                          minLength={6}
                          maxLength={6}
                          className="h-[52px] w-full lg:max-w-full px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                          placeholder={T("Enter new password")}
                          defaultValue={formData?.new_password || ""}
                          onChange={(e) =>
                            changeInput("new_password", e.target.value)
                          }
                        />
                        <div className="bg-mark"></div>
                        <div
                          className={`w-6 h-6 flex justify-center ${
                            showNewPassword ? "items-center" : "items-end"
                          } absolute right-4 top-3.5 z-10 cursor-pointer`}
                          onClick={() => triggerShowNewPassword()}
                        >
                          {showNewPassword && <IconOpenEye />}
                          {!showNewPassword && <IconCloseEye />}
                        </div>
                      </div>
                      {error.new_password && (
                        <p className=" z-10 text-suzu-error text-sm">
                          {error.new_password}
                        </p>
                      )}
                    </div>
                    <div className="mb-6 lg:mb-[25px]">
                      <label
                        htmlFor="form_confirm_password"
                        className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                      >
                        {T("Confirm New Password")}
                      </label>
                      <div className="w-full p-[1px] rounded-[10px] relative">
                        <input
                          id="form_confirm_password"
                          type={showConfirmPassword ? "text" : "password"}
                          minLength={6}
                          maxLength={6}
                          className="h-[52px] w-full lg:max-w-full  px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                          placeholder={T("Enter new password again")}
                          defaultValue={formData?.confirm_password || ""}
                          onChange={(e) =>
                            changeInput("confirm_password", e.target.value)
                          }
                        />
                        <div className="bg-mark"></div>
                        <div
                          className={`w-6 h-6 flex justify-center ${
                            showConfirmPassword ? "items-center" : "items-end"
                          } absolute right-4 top-3.5 z-10 cursor-pointer`}
                          onClick={() => triggerShowConfirmPassword()}
                        >
                          {showConfirmPassword && <IconOpenEye />}
                          {!showConfirmPassword && <IconCloseEye />}
                        </div>
                      </div>
                      {error.confirm_password && (
                        <p className=" z-10 text-suzu-error text-sm">
                          {error.confirm_password}
                        </p>
                      )}
                    </div>
                    <div className="pt-4 pb-[20px]">
                      {error.form && (
                        <p className="mb-2 text-suzu-error text-sm">
                          {error.form}
                        </p>
                      )}
                      <button
                        className="bg-black w-full max-w-full block mx-auto lg:mx-0 h-[52px] text-center text-white rounded-[15px]"
                        type="submit"
                      >
                        {T("Save")}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </ContainerView>
    </Container>
  );
};
